import LotBonus from "../jsx/page/Bonus/LotBonus.js";
import Mt5Profit from "../jsx/page/Bonus/Mt5Profit.js";
import ProfitSharingList from "../jsx/page/Bonus/ProfitSharingList.js";
import SameRankBonus from "../jsx/page/Bonus/SameRankBonus.js";
import Dashboard from "../jsx/page/Dashboard/Dashboard";
import DirectDownline from "../jsx/page/Member/DirectDownline";
import LookupSponsor from "../jsx/page/Member/LookupSponsor";
import MemberDetails from "../jsx/page/Member/MemberDetails";
import MemberKyc from "../jsx/page/Member/MemberKyc.js";
import RankLog from "../jsx/page/Member/RankLog";
import TeamInvestment from "../jsx/page/Member/TeamInvestment.js";
import InvestmentRecord from "../jsx/page/MT5/InvestmentRecord.js";
import Mt5AccountList from "../jsx/page/MT5/Mt5AccountList.js";
import AddAdmin from "../jsx/page/System/Admin/AddAdmin.js";
import AdminList from "../jsx/page/System/Admin/AdminList.js";
import EditAdmin from "../jsx/page/System/Admin/EditAdmin.js";
import AddAnnouncement from "../jsx/page/System/Announcement/AddAnnouncement.js";
import Announcement from "../jsx/page/System/Announcement/Announcement.js";
import EditAnnouncement from "../jsx/page/System/Announcement/EditAnnouncement.js";
import ChangePassword from "../jsx/page/System/ChangePassword.js";
import OTCtag from "../jsx/page/System/OTCtag.js";
import Setting from "../jsx/page/System/Setting/Setting.js";
import Adjustment from "../jsx/page/Wallet/Adjustment.js";
import Balance from "../jsx/page/Wallet/Balance.js";
import CrmDeposit from "../jsx/page/Wallet/CrmDeposit.js";
import Mt5Deposit from "../jsx/page/Wallet/Mt5Deposit.js";
import Mt5Withdraw from "../jsx/page/Wallet/Mt5Withdraw.js";
import Transaction from "../jsx/page/Wallet/Transaction.js";
import Transfer from "../jsx/page/Wallet/Transfer.js";
import Withdrawal from "../jsx/page/Wallet/Withdrawal.js";
import AdminDashboard from "../jsx/page/System/AdminDashboard.js";


const routes = [
    { url: "/", component: Dashboard, name: "Dashboard" },
    { url: "/dashboard", component: Dashboard, name: "Dashboard" },
    { url: "/member/member-details", component: MemberDetails, name: "Member Details" },
    { url: "/member/lookup-sponsor", component: LookupSponsor, name: "Lookup Sponsor" },
    { url: "/member/direct-downline", component: DirectDownline, name: "Direct Downline" },
    { url: "/member/memberKYC", component: MemberKyc, name: "Member KYC" },
    { url: "/member/rankLog", component: RankLog, name: "Rank Log" },
    { url: "/member/teamHierarchy", component: TeamInvestment, name: "Overall Team Hierarchy" },

    { url: "/wallet/transfer", component: Transfer, name: "Internal Transfer" },
    { url: "/wallet/transaction", component: Transaction, name: "Wallet Transaction" },
    { url: "/wallet/balance", component: Balance, name: "Wallet Balance" },
    { url: "/wallet/adjust", component: Adjustment, name: "Wallet Adjust" },
    { url: "/wallet/walletWithdrawal", component: Withdrawal, name: "CRM Withdrawal" },
    { url: "/wallet/walletMt5Deposit", component: Mt5Deposit, name: "MT5 Deposit" },
    { url: "/wallet/walletMt5Withdraw", component: Mt5Withdraw, name: "TRANSFER_FROM_MT5" },
    { url: "/wallet/walletCrmDeposit", component: CrmDeposit, name: "CRM Deposit" },
   
    { url: "/bonus/profitSharingBonusList", component: ProfitSharingList, name: "Profit Sharing Bonus" },
    { url: "/bonus/mt5ProfitList", component: Mt5Profit, name: "MT5 Profit" },
    { url: "/bonus/lotBonusList", component: LotBonus, name: "Lot Rebate Bonus" },
    { url: "/bonus/sameRankBonusList", component: SameRankBonus, name: "Same Rank Bonus" },
    
    { url: "/mt5/mt5AccountList", component: Mt5AccountList, name: "MT5 Account" },
    { url: "/mt5/investmentRecord", component: InvestmentRecord, name: "Investment Record" },
   
    { url: "/system/otcTagList", component: OTCtag, name: "OTC Tag List" },
    { url: "/system/announcement", component: Announcement, name: "Announcement" },
    { url: "/system/announcement/new", component: AddAnnouncement, name: "New Announcement" },
    { url: "/system/announcement/:id", component: EditAnnouncement, name: "Edit Announcement" },
    { url: "/system/change-password", component: ChangePassword, name: "Change Password" },
    { url: "/system/setting", component: Setting, name: "Setting" },
    { url: "/system/admin", component: AdminList, name: "Admin" },
    { url: "/system/admin/new", component: AddAdmin, name: "New Admin" },
    { url: "/system/admin/edit/:id", component: EditAdmin, name: "Edit Admin" },
    { url: "/system/adminDashboard", component: AdminDashboard, name: "Admin Dashboard" },
];

export default routes;